//Reset data
export const RESET = "CARACTERISATION_LIST_RESET"

//Loading
export const SET_TOGGLE_LOADING = "CARACTERISATION_LIST_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "CARACTERISATION_LIST_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "CARACTERISATION_LIST_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "CARACTERISATION_LIST_SET_MESSAGE"
export const SET_IS_SUCCESS = "CARACTERISATION_LIST_SET_IS_SUCCESS"
export const SET_IS_ERROR = "CARACTERISATION_LIST_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "CARACTERISATION_LIST_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "CARACTERISATION_LIST_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "CARACTERISATION_LIST_SET_HIDE_MESSAGE"

//Data
export const SET_ITEMS = "CARACTERISATION_LIST_SET_ITEMS"
export const SET_CURRENT_ITEM = "CARACTERISATION_LIST_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "CARACTERISATION_LIST_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "CARACTERISATION_LIST_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "CARACTERISATION_LIST_SET_HIDE_MODAL"


export const SET_MODAL = "CARACTERISATION_LIST_SET_MODAL"
export const SET_MODAL_CONTENT = "CARACTERISATION_LIST_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "CARACTERISATION_LIST_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "CARACTERISATION_LIST_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "CARACTERISATION_LIST_SET_MODAL_TYPE"